import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import trans from '../../translations.json';
import { getDatesRange, dateFormater } from '../utils';

class BySourceSettingTable extends React.Component {
  state = {
    data: undefined,
  };

  render() {
    const latestDate = Object.keys(
        Object.values(ReducedData.dataSourceSetting)[1],
      )
        .sort((a, b) => new Date(a) - new Date(b))
        .pop(),
      dateRange = getDatesRange('2020-01-15', latestDate);

    var previousDayData;
    var tableData = dateRange.map((date) => {
      var dayData = Object.values(dict.sourcesSetting).reduce(
        (sum, curr) => {
          //check if cateogry is empty

          const dates = ReducedData.dataSourceSetting[curr],
            dateValue =
              dates &&
              ReducedData.dataSourceSetting[curr][date + 'T00:00:00'];

          if (!dates || !dateValue) return sum;

          if (this.props.selectedTab === dict.tabs.newCases) {
            sum[curr] = dateValue;
          } else {
            if (previousDayData && previousDayData[curr]) {
              sum[curr] = previousDayData[curr] + (dateValue || 0);
            } else {
              sum[curr] = dateValue;
            }
          }

          return sum;
        },
        {
          date: dateFormater(date),
        },
      );

      previousDayData = dayData;

      return dayData;
    });

    tableData.reverse();

    const columns = Object.values(dict.sourcesSetting).map((item) => {
      return {
        title:
          trans.activeOutbreaks[
            Object.keys(dict.sourcesSetting)[
              Object.values(dict.sourcesSetting).indexOf(item)
            ]
          ][this.props.lang],
        dataIndex: item,
        key: item,
        render: (text) => {
          if (text) {
            return text.toLocaleString();
          }
        },
        //width: "10%",
      };
    });

    columns.unshift({
      title: trans.date[this.props.lang],
      dataIndex: 'date',
      key: 'date',
      width: '30%',
    });

    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default BySourceSettingTable;
